import { enLang, enCurrency } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';
import { translateService } from 'services/TranslateService';
import { paymentService } from './PaymentService';
import { getCountryByLang, getLanguegByNavigator } from 'shared/utils/getLanguage';
import { currencyService } from './CurrencyService';
import { BehaviorSubject } from 'rxjs';
import { parameterService } from './ParameterService';
import { enParameters } from 'enums/enParameters';

interface ICountrySelect {
  id: string;
  currency: enCurrency;
  lang: enLang;
  text: string;
  macro: string;
}

const COUNTRIES: ICountrySelect[] = [
  { id: 'brasil', currency: enCurrency.BRL, lang: enLang.PT_BR, text: 'Brasil', macro: 'br' },
  { id: 'unitedstates', currency: enCurrency.USD, lang: enLang.EN_US, text: 'United States', macro: 'us' },
  { id: 'colombia', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Colombia', macro: 'co' },
  { id: 'mexico', currency: enCurrency.USD, lang: enLang.EN_US, text: 'México', macro: 'mx' },
  { id: 'portugal', currency: enCurrency.USD, lang: enLang.PT_PT, text: 'Portugal', macro: 'pt' },
  { id: 'spain', currency: enCurrency.USD, lang: enLang.EN_US, text: 'España', macro: 'es' },
  { id: 'argentina', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Argentina', macro: 'ar' },
  { id: 'peru', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Perú', macro: 'pe' },
  { id: 'chile', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Chile', macro: 'cl' },
  { id: 'ecuador', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Ecuador', macro: 'ec' },
  { id: 'other', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Other', macro: 'other' }
];
export class LangService {
  private country$ = new BehaviorSubject<ICountrySelect>(COUNTRIES[0]);

  constructor() {
    const langParameter = parameterService.getSync(enParameters.lang);
    if (!!langParameter) {
      const dataLang = getCountryByLang(langParameter as enLang);
      this.setLangByLanguage(dataLang.lang, dataLang.countryMacro);

      return;
    }

    if (window?.BETA_FEATURE_NAVIGATOR) {
      const { lang, countryMacro } = getLanguegByNavigator();

      this.setLangByLanguage(lang, countryMacro);

      return;
    }

    this.setLangByCountry('Brasil');
  }

  public getLang(): Observable<enLang> {
    return this.country$
      .asObservable()
      .map((c) => c.lang)
      .distinctUntilChanged();
  }

  public getCountries() {
    return COUNTRIES;
  }

  public getSelectedCountry() {
    return this.country$.asObservable();
  }
  public setLangByCountry(countryName: string) {
    const country = COUNTRIES.find((c) => c.text === countryName);

    if (!country) {
      const countryDefault = COUNTRIES[0];

      this.setCountryCurrencyTranslate(countryDefault);
      return;
    }

    this.setCountryCurrencyTranslate(country);
  }

  private setLangByLanguage(lang: enLang, countryMacro: string) {
    const countryByMacro = COUNTRIES.find((c) => c.macro === countryMacro);

    if (!countryByMacro) {
      const countryByLang = COUNTRIES.reverse().find((c) => c.lang === lang) || COUNTRIES[10];

      this.setCountryCurrencyTranslate(countryByLang);
      return;
    }

    this.setCountryCurrencyTranslate(countryByMacro);
  }

  private setCountryCurrencyTranslate(country: ICountrySelect) {
    this.country$.next(country);
    translateService.setLang(country.lang);
    currencyService.setCurrency(country.currency);
    this.setPersonTypeByLang(country.lang);
  }

  private setPersonTypeByLang(lang: enLang) {
    if (lang === enLang.PT_BR) {
      paymentService.setData({ personType: 'F' });
    } else {
      paymentService.setData({ personType: 'E' });
    }
  }
}

// tslint:disable-next-line:variable-name
export const LangServiceFactory = () => new LangService();

export const langService = LangServiceFactory();
